import Button from 'components/forms/Button'
import RightRobotCard from './common/RightRobotCard'
import useWindowSize from 'components/util/useWindowSize'
import Link from 'next/link'

const SaaSOfficeSolutionCard = () => {
  const size = useWindowSize()
  return (
    <RightRobotCard
      imageContainerWidth={size.isLgOrHigher ? '50%' : '100%'}
      image={{
        alt: 'Robot upper half for SaaS solution',
        desktop: {
          dimensions: {
            height: 584,
            width: 518,
          },
          src: '/images/new/robot-upperhalf-cut.png',
        },
        mobile: {
          dimensions: {
            height: 871,
            width: 649,
          },
          src: '/images/new/robot-upperhalf.png',
        },
      }}
      imageStyle={{
        height: '100%',
        objectFit: 'contain',
        objectPosition: 'right',
        width: '100%',
      }}
    >
      <div
        className='d-flex flex-1 flex-column px-4 pt-8 pb-0 pe-lg-0 ps-lg-20 pt-lg-9 pb-lg-6 fw-semibold'
        style={{
          marginRight: size.isLgOrHigher ? '-25%' : undefined,
        }}
      >
        <h2 className='fw-semibold mb-6 fs-fluid-36-80 lh-105'>
          For Partners and Enterprise Solutions.
        </h2>
        <div
          className='lh-132 fs-fluid-18-22'
          style={{
            maxWidth: size.isLgOrHigher ? '75%' : '100%',
          }}
        >
          <h3 className='fw-semibold fs-fluid-20-28 mb-0'>
            A virtual office SaaS service for your clients.
          </h3>
          <br />
          <span>
            Create Your Own virtual office solution to expand your client
            service offering with our SaaS solution. Our solution includes a
            virtual business address, which enhances professionalism and trust
            while safeguarding personal information. Generate an incremental
            revenue stream, increase efficiency and expand your client
            proposition.
          </span>
        </div>
        <Link className='align-self-lg-start mt-8' href={'/enterprise'}>
          <Button className='w-100 w-lg-auto'>Find Out More</Button>
        </Link>
      </div>
    </RightRobotCard>
  )
}

export default SaaSOfficeSolutionCard
